// extracted by mini-css-extract-plugin
export default {"Image":"TeamMemberView_Image__D1R74","Container":"TeamMemberView_Container__DBYBJ"};